import TagTypesIcon from 'components/TagTypesIcon';

export const resolveDescription = (options, code) =>
  options?.find((option) => option.Code === code)?.Description || code || '';

export const resolveIcon = (iconIndex) => (iconIndex ? TagTypesIcon[iconIndex] : TagTypesIcon[0]);
